<script>
  import Header from "../header.svelte";
  import { onMount } from "svelte";
  import * as XLSX from "xlsx";
  import ResponsiveTable from '../../utils/responsivetable3.svelte';
  import { getToken, doFetch } from '../../utils/Fetching.js';
  import Swal from "sweetalert2";
  import { api_host, user_store } from "../../stores.js";
  import { toast_message } from "../../utils/toast_message.js";
  import { init_data } from '../../init.js';


  let content_title = "Import Clients to Your Account";
  let is_busy = false;
  let fileInput;
  let users = [];

  let table_header_config = [
    {'t': 'First Name', 'fm': 'first_name', 'a': true},
    {'t': 'Last Name', 'fm': 'last_name', 'a': true},
    {'t': 'Address', 'fm': 'street', 'a': true},
    {'t': 'City', 'fm': 'city', 'a': true},
    {'t': 'State', 'fm': 'state', 'a': true},
    {'t': 'Zip', 'fm': 'zipcode', 'a': true},
    {'t': 'Email', 'fm': 'email', 'a': true},
    {'t': 'Phone', 'fm': 'mobile_phone', 'a': true},
    {'t': 'Status', 'fm': 'status', 'a': true},
    {'t': 'Error', 'fm': 'html_error', 'a': true},
  ];

  const validateUser = (user) => {
    let msg = '';
    if (!user.first_name.length) {
      msg = "First name is required.";
    }
    if (!user.last_name.length) {
      msg = "Last name is required.";
    }
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    if (!user.email.match(mailformat)) {
      msg = "Email is not valid";
    }
    if (!user.street.length) {
      msg = "Street is required.";
    }
    if (!user.city.length) {
      msg = "City is required.";
    }
    if (!user.state.length) {
      msg = "State is required.";
    }
    if (!user.mobile_phone.length) {
      msg = "Phone is required.";
    }
    return msg;
  };

  function handleFile(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function(e) {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Assuming the first sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Convert sheet to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        console.log('excel data', jsonData);
        users = jsonData.map(_u => {
          const u = {
            first_name: `${_u.Client_First_Name ?? ''}`.trim(),
            last_name: `${_u.Client_Last_Name ?? ''}`.trim(),
            email: `${_u.Email_Address ?? ''}`.trim().toLowerCase(),
            role: 'client',
            street: `${_u.Address ?? ''}`.trim(),
            city: `${_u.City ?? ''}`.trim(),
            state: `${_u.State ?? ''}`.trim(),
            zipcode: `${_u.Zip ?? ''}`.trim(),
            mobile_phone: `${_u.Phone ?? ''}`.trim(),
            home_phone: `${_u.Phone ?? ''}`.trim(),
            password: Math.random().toString(36).slice(-12),
            carrier: 'Verizon',
            profile_type: '',
            lawn_equipment: '',
            hear_about_us: '',
            additional_comments: '',
            internal_comments: '',
            error: '',
            html_error: '',
            status: '',
          };
          u.error = validateUser(u);
          u.html_error = `<span style="color: red;">${u.error}</span>`;
          return u;
        });

        console.log('users', users);
      };
      reader.readAsArrayBuffer(file);
    }
  }

  const saveUsers = async () => {
    if (users.filter(_u => _u.error.length > 0).length > 0) {
      await Swal.fire({
        title: "Please check the errors and correct them.",
        buttonsStyling: true,
        confirmButtonClass: "button",
        confirmButtonText: 'Ok',
        icon: "warning"
      });
      return;
    }
    is_busy = true;

    for (let i = 0; i < users.length; i++) {
      const user = users[i];
      const { auth_type, auth_token, domain_code } = getToken();
      const res = await doFetch(
          api_host + "/api/create/user",
          'POST',
          user,
          { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
      );
      if (res.status) {
        toast_message(true, `${user.first_name} ${user.last_name} - created`, 2000);
        user.status = 'Imported';
      }
      else { 
        if (res.msg == 'User already existed')
          toast_message(false, `${user.first_name} ${user.last_name} - already exists`, 2000); 
        else
          toast_message(false, `${user.first_name} ${user.last_name} - ${res.msg}`, 2000); 
        user.status = `<span style="color: red;">${res.msg}</span>`;
        users = users;
      }
    }

    init_data('users');

    is_busy = false;
  }
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">

  <button class="import" on:click={() => {
    const tag = document.getElementById('file_input');
    tag.click();
    tag.value = '';
  }} :disabled={is_busy}><i class="far fa-user-plus"></i> Import</button>
  <input type="file" id="file_input" bind:this="{fileInput}" accept=".xlsx, .xls" on:change="{handleFile}" style="visibility: hidden;" />
  <br />
  <br />
  <h5 style="padding-left: 15px;">Instructions:</h5>
  <ul>
    <li>
      Download and use the sample Excel file below.
      <br/>
      <a href="https://docs.google.com/spreadsheets/d/1aA2CWOsSf5MwR4EfLdaBwwnIS5zX8Jcs/edit?usp=sharing&ouid=101191163692569515918&rtpof=true&sd=true">
        Sample_file (Excel)
      </a>
    </li>
    <li>Enter or copy/paste the client information into the corresponding columns. All columns are required, except for the zip code, which is optional.</li>
    <li>Click the <strong>"Import"</strong> button and select your client file.</li>
    <li>Your clients will appear in the Import table. Click <strong>“Create Client Records”</strong> to create clients in your account.</li>
    <li>The imported clients can be found under <strong>Users >> Clients</strong>.</li>
  </ul>
  <br />
  <p style="padding-left: 15px;">For details on how to use this feature, please click <a target="_blank" href="https://houseofyards.tawk.help/article/import-clients-feature">here</a>.</p>

  {#if users.length > 0}
  <div class="tableholder">
    <ResponsiveTable
      table_data={users} 
      num_per_page={500}
      total_items={users.length}
      bind:is_busy={is_busy}
      bind:table_header_config={table_header_config}
    />
  </div>
  <div class="saveholder">
    <button class="save" on:click={saveUsers} :disabled={is_busy}><i class="far fa-save"></i> Create Client Records</button>
  </div>
  {/if}
  
</div>

<style>
.import {
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 20px;
}
.save {
  background-color: #357a38;
  color: white;
  margin-top: 40px;
  padding-left: 20px;
  padding-right: 20px;
}
li {
  list-style-type: decimal;
}
</style>